import { observer } from 'owa-mobx-react';
import { setNextStyleIsEnabled, setHeadlessThemeIsEnabled } from 'owa-acui';
import { useAppTheme } from './useAppTheme';

export const RibbonThemeV9: React.FC<{
    children: React.ReactNode;
}> = observer(({ children }) => {
    setNextStyleIsEnabled(true);
    setHeadlessThemeIsEnabled(true);
    useAppTheme();

    return children;
}, 'RibbonThemeV9');
